var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoReply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 57,
    viewBox: "0 0 113 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0191 16.0766C24.0191 14.412 25.3666 13.0635 27.0346 13.0635C28.6949 13.0635 30.0462 14.412 30.0462 16.0766C30.0462 17.7372 28.6949 19.082 27.0346 19.082C25.3666 19.082 24.0191 17.7372 24.0191 16.0766ZM24.1907 20.7735L20.4223 25.7247L19.4686 27.0077L24.0286 33.1418C24.2795 33.477 24.4147 33.8855 24.4108 34.3054L24.3799 42.4162C24.3799 42.8015 24.0672 43.1097 23.6849 43.1097H23.1521C22.8046 43.1097 22.5073 42.8515 22.461 42.5086L21.4687 35.1994C21.4339 34.9373 21.2988 34.7023 21.0903 34.5405L15.8662 30.3984L13.3913 31.905C13.0631 32.1015 12.6885 32.2094 12.3063 32.2171L1.97016 32.3866C1.669 32.3905 1.37556 32.2672 1.17092 32.0475L0.124562 30.9263C-0.13027 30.6566 0.028035 30.2058 0.3987 30.1557L11.1016 28.6376L19.237 19.9142L12.6615 18.6774C12.4723 18.6427 12.2947 18.5618 12.148 18.4424L11.0862 17.587C10.8545 17.402 10.9858 17.0321 11.2831 17.0321H15.0708L21.9745 16.9859C22.2409 16.9821 22.488 17.1208 22.6309 17.3442L24.2293 19.9065C24.3992 20.1762 24.3838 20.523 24.1907 20.7735Z",
    fill: "#02D34A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0435 23.9583C46.0435 22.4377 44.8588 21.501 43.3144 21.501H39.1855V26.4704H43.3144C44.8588 26.4704 46.0435 25.5299 46.0435 23.9583ZM45.6565 36.4641L42.0476 29.9192H39.1855V36.4641H35.2717V18.0483H43.8657C47.6935 18.0483 50.063 20.5605 50.063 23.9857C50.063 27.2151 47.9985 28.9826 46.0162 29.4489L50.1724 36.4641H45.6565Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9812 36.4641V18.0483H65.9778V21.501H56.8912V25.3653H65.7863V28.814H56.8912V33.0114H65.9778V36.4641H52.9812Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8075 23.9857C79.8075 22.4377 78.6267 21.501 77.0823 21.501H72.9495V26.443H77.0823C78.6267 26.443 79.8075 25.5024 79.8075 23.9857ZM69.0396 36.4641V18.0483H77.6336C81.6257 18.0483 83.8035 20.7525 83.8035 23.9857C83.8035 27.1876 81.5983 29.8918 77.6336 29.8918H72.9495V36.4641H69.0396Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0873 36.4641V18.0483H90.0285V33.0114H97.7936V36.4641H86.0873Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.064 36.4641V28.9277L95.0143 18.0483H99.4756L104.019 25.4201L108.562 18.0483H113L105.974 28.9277V36.4641H102.064Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoReply);
export default __webpack_public_path__ + "static/media/logo-reply.d36566e54bf5113a936423b02be7f5f7.svg";
export { ForwardRef as ReactComponent };